import Vue from 'vue'
import App from './App.vue'
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/vi";
import './scss/index.scss'
import './lib/vee-validate';
import 'element-ui/packages/theme-chalk/src/index.scss';
import './scss/components/_introjs.scss';
import router from "./router";
import IconFont from "./components/common/IconFont.vue";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import InputError from "@/components/common/InputError.vue"
import moment from "moment";
import VueNativeNotification from 'vue-native-notification'
Vue.use(VueNativeNotification, {
  requestOnNotify: true
})
Vue.prototype.moment = moment;
Vue.component("IconFont", IconFont);
Vue.component("InputError", InputError);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
import LinkifiedText from "@/components/common/LinkifiedText.vue";
Vue.component("LinkifiedText", LinkifiedText);
Vue.use(ElementUI, { locale, size: 'small' });
Vue.config.productionTip = false

import VueSlideBar from 'vue-slide-bar';

Vue.component('vue-slide-bar', VueSlideBar);

import Socket from "@/lib/websocket";
import { HTTP } from './lib/http-common';


const appState = Vue.observable({
  name: '',
  role: {},
  user: {},
  sessionId: '',
  globalProcessId: 0,
  columnListAll: [],
  columnList: [],
  permissionList: [],
  employeeList: [],
  employeeTeam: [],
  storageList: [],
  storageAll: [],
  processList: [],
  // workflowList: [],
  reportList: [],
  codes: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10'],
  omicall: {
    status: 'INACTIVE',
    domain: '',
    username: '',
    password: '',
  },
  localData: {},
  colorOrder: {
    "TẤT CẢ": "#28a745",
    "CHỜ XÁC NHẬN": "#6c757d",
    "KIỂM KÊ": "#6c757d",
    "CHỜ HÀNG": "#6c757d",
    MỚI: "#007bff",
    "HẸN GIAO": "#007bff",
    "CHỜ ĐÓNG GÓI": "#17a2b8",
    "ĐANG ĐÓNG GÓI": "#17a2b8",
    "CHỜ GỬI HÀNG": "#17a2b8",
    "ĐÃ GỬI HÀNG": "#ffc107",
    "ĐANG GIAO": "#ffc107",
    "THÀNH CÔNG": "#28a745",
    HOÀN: "#dc3545",
    "THẤT THU": "#dc3545",
    HỦY: "#dc3545"
  },
  stringeeNumbers: [],
  fromNumberStringee: '',
  countNotification: 0,
  countUnreadNoti: 0,
  countUnreadNotiAppointment: 0,
  notifications: [],
  notificationAppointments: [],
  newContactIds: new Set(),
  showNotifyPopover: false,
  swCall: {
    status: 'INACTIVE'
  },
  isEmbed: false,
  shopExpired: false,
});

const EventBus = new Vue();

Vue.mixin({
  data: () => ({
    app: appState
  }),
  computed: {
    $bus() {
      return EventBus;
    },
    columnList() {
      // if(this.app.globalProcessId){
      //   const currentProcess = this.app.processList.find(item => item.id === this.app.globalProcessId);

      //   const columnList = this.app.columnListAll.filter(column => 
      //     mergedColumns.includes(column.name)
      //   );        
      //   return columnList;
      // }
      return this.app.columnListAll;
    },
    columnListByProcess() {
      if(this.app.globalProcessId){
        const currentProcess = this.app.processList.find(item => item.id === this.app.globalProcessId);

        const workflows = currentProcess.workflowList;
 
        if(workflows){
          const mergedColumns = Array.from(new Set(
            workflows.flatMap(wf => JSON.parse(wf.columnList))
          ));
          const columnList = this.app.columnListAll.filter(column => 
            mergedColumns.includes(column.name)
          );        
          return columnList;
        }
      }
      return this.app.columnListAll;
    },
    workflowList() {
      if (this.app.globalProcessId) {
        let currentProcess = this.app.processList.find(item => item.id === this.app.globalProcessId);
        if (!currentProcess) {
          let key = `${this.app.user.id}_${this.app.user.swUsername}`;
          this.setProcessLocalStorage(key, 'all');
          this.app.globalProcessId = 'all'
          currentProcess = this.app.processList.find(item => item.id === this.app.globalProcessId);
        }

        return currentProcess.workflowList;
      }
      return [];
    },
    permissionContactRead() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CONTACT_READ");
      }
      return false;
    },
    permissionContactWrite() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CONTACT_WRITE");
      }
      return false;
    },
    permissionContactImport() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CONTACT_IMPORT");
      }
      return false;
    },
    permissionSettingDisplayRead() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("SETTING_DISPLAY_READ");
      }
      return false;
    },
    permissionSettingDisplayWrite() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("SETTING_DISPLAY_WRITE");
      }
      return false;
    },
    permissionContactHide() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CONTACT_HIDE");
      }
      return false;
    },
    permissionContactLog() {
      if (this.app.user.type === "ADMIN") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CONTACT_NOTE");
      }
      return false;
    },
    permissionStatisticRead() {
      if (this.app.user.type === "ADMIN" || this.app.role.permissionList === "all") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("SETTING_STATISTIC_READ");
      }
      return false;
    },
    permissionStatisticWrite() {
      if (this.app.user.type === "ADMIN" || this.app.role.permissionList === "all") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("SETTING_STATISTIC_WRITE");
      }
      return false;
    },
    permissionCallCenter() {
      if (this.app.user.type === "ADMIN" || this.app.role.permissionList === "all") {
        return true;
      }
      if (this.app.role.permissionList) {
        return this.checkPermission("CALL_CENTER");
      }
      return false;
    },
  },
  methods: {
    alert(type, message) {
      if (type === "success") {
        this.$message({
          showClose: true,
          message: message,
          type: "success"
        });
      } else if (type === "error") {
        this.$message({
          showClose: true,
          message: message,
          type: "error"
        });
      }
    },
    copy(value) {
      const el = document.createElement("textarea");
      el.value = value;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    },

    dateTimeFormat(ts, format = 'HH:mm:ss DD/MM/YYYY') {
      return moment(Number(ts)).format(format);
    },
    convertTime(time) {
      return moment(Date.parse(time)).format("YYYY-MM-DD hh:mm:ss");
    },
    convertTimeOrderDetail(time) {
      return moment(Date.parse(time)).format("hh:mm:ss DD/MM/YYYY");
    },
    getProcessFromLocalStorge() {
      const processActive =JSON.parse(localStorage.getItem("processActive") || "{}")
      const processId = processActive[this.app.user.id + '_' + this.app.user.swUsername]
      const hasProcess = this.app.processList.some(process => process.id === processId);

      if(hasProcess){
        return processActive;
      }
      else{
        const process = {
          [this.app.user.id + '_' + this.app.user.swUsername] : 'all'
        }
         return process;
      }
    },
    setProcessLocalStorage(key, processId) {
      let processMap = this.getProcessFromLocalStorge();
      processMap[key] = processId;
      localStorage.setItem("processActive", JSON.stringify(processMap));
    },

    // Danh sách nhân viên hiển thị cho 1 contact = nhân viên trong quyền quản lý
    // (app.employeeTeam) + nhân viên cũ của contact nằm ngoài quyền đó.
    // Nhóm sau bắt buộc phải có mặt: mọi API cập nhật nhân viên đều gửi lên
    // TOÀN BỘ danh sách, ẩn họ đi đồng nghĩa với gỡ họ khỏi contact.
    // Nhận vào mảng object nhân viên hoặc mảng id đều được.
    employeeOptionsForContact(currentEmployees) {
      const team = this.app.employeeTeam || [];
      const teamIds = new Set(team.map(e => e.id));
      const seen = new Set();
      const outsiders = [];

      (currentEmployees || []).forEach(item => {
        const employee = item && typeof item === "object" ? item : null;
        const id = employee ? employee.id : item;
        if (id == null || teamIds.has(id) || seen.has(id)) return;
        seen.add(id);

        const detail = (this.app.employeeList || []).find(e => e.id === id);
        outsiders.push({
          ...detail,
          ...employee,
          id,
          username: employee?.username || detail?.username || "",
          accessible: false,
          // locked: hiển thị cho biết nhưng không cho bỏ chọn.
          locked: true
        });
      });

      return outsiders.length ? [...team, ...outsiders] : team;
    },
    // username có dạng "companyCode/tenNhanVien" — lấy phần tên để hiển thị.
    employeeShortName(employee) {
      const username = employee?.username || "";
      return username.split("/")[1] || username;
    },

    async initWebsocket() {
      console.log(this.app.user.swUsername);

      if (Socket.isConnected) Socket.disconnect();
      Socket.requestConnect(stompClient => {
        stompClient.subscribe("/session/" + this.app.sessionId, frame => {
          try {
            let body = JSON.parse(frame.body);
            console.log(body);

            if (body.event === "ReportResponse") {
              this.$bus.$emit("reportResponse_event", body.data);
            } else if (body.type == "Statistic_Contact_General") {
              this.$bus.$emit("Statistic_Contact_General", body);
            } else if (body.event == "ContactExport") {
              this.$bus.$emit("ContactExport", body);
            } else if (body.event == "RevenueDashboard") {
              this.$bus.$emit("RevenueDashboard", body);
            }
          } catch (e) {
            //
          }
        });
        stompClient.subscribe("/notification/" + this.app.user.swUsernameLite, frame => {
          try {
            let body = JSON.parse(frame.body);
            console.log(body);
            if (body.event == "read") {
              this.$bus.$emit("conversationRead", body.conversation);
            }
          } catch (e) {
            console.log(123, e);

            //
          }
        });
        stompClient.subscribe("/user/" + this.app.user.swUsernameLite + "/", frame => {
          try {
            let body = JSON.parse(frame.body);
            console.log(body);
            if (body.event == "read") {
              this.$bus.$emit("conversationRead", body.conversation);
            } else if (body.event == "WebhookMapTemplate") {
              this.$bus.$emit("WebhookMapTemplate", body);
            } else if (body.event === "UPDATE_MASK_PHONE") {
              // Ẩn/hiện SĐT cấp công ty: cập nhật user.maskPhone -> UI mask/unmask theo.
              this.$set(this.app.user, "maskPhone", body.maskPhone);
            } else if (body.event === "logoutUser") {
              window.location.reload();
            } else if (body.event == "grantEmployee") {
              const contactPhone = body.data.contactPhone;
              const contactName = body.data.contactName;
              const employees = body.data.employees.join(', ');
              const message = "Khách hàng " + contactName + '-' + contactPhone + " vừa được chia cho " + employees;
              this.notifyMe(message);
              // this.fetchNotification()
            } else if (body.event == 'Notification') {
              // const contactPhone = body.data.contactPhone;
              // const contactName = body.data.contactName;
              // const employees = body.data.employees.join(', ');
              const data = JSON.parse(body.data);
              let message = this.handleMessageNoti(data);
              this.notifyMe(message);
              this.$bus.$emit("notification", data);
            } else if (body.event == "Task") {
              // Task notifications come from 3 backend paths (see TaskAutomation
              // executor, notifyAssignment, reminder fire):
              //   type=AUTOMATION → payload: {ruleId, taskId, message}
              //   type=ASSIGN     → payload: {task: <json string>}
              //   type=REMIND     → payload: {task: <json string>}
              this.handleTaskSocket(body);
            } else if (body.event == "PinContact") {
              this.$bus.$emit("pinContact");
            } else if (body.event == "Appointment") {
              this.$bus.$emit("appointment", body);
            } else if (body.event == "NotificationAppointment") {
              const data = JSON.parse(body.data);
              let message = this.handleMessageNotiAppointment(data);
              this.notifyMe(message);
              this.$bus.$emit("notificationAppointment", body);
            } else if (body.event == "pinListData") {
              this.$bus.$emit("pinListData", body);
            } else if (body.event == "call_AI") {
              this.$bus.$emit("call_AI", body);
            }
          } catch (e) {
            console.log(e);

          }
        });
        stompClient.subscribe("/user/" + this.app.user.username + "/", frame => {
          try {
            let body = JSON.parse(frame.body);
            console.log(body);
            if (body.event == "read") {
              this.$bus.$emit("conversationRead", body.conversation);
            } else if (body.event == "WebhookMapTemplate") {
              this.$bus.$emit("WebhookMapTemplate", body);
            } else if (body.event === "UPDATE_MASK_PHONE") {
              // Ẩn/hiện SĐT cấp công ty: cập nhật user.maskPhone -> UI mask/unmask theo.
              this.$set(this.app.user, "maskPhone", body.maskPhone);
            } else if (body.event == "Task") {
              // Task automation / assignment / reminder push from backend.
              // Backend pushService.pushEvent(receiver, ...) where receiver is
              // task.assigneeUsername — that may match this channel's username
              // OR the lighter swUsernameLite one, so we listen on both.
              this.handleTaskSocket(body);
            }
            else if (body.event == "grantEmployee") {
              const contactPhone = body.data.contactPhone;
              const contactName = body.data.contactName;
              const employees = body.data.employees.join(', ');
              const message = "Khách hàng " + contactName + '-' + contactPhone + " vừa được chia cho " + employees;
              this.notifyMe(message);
              // this.fetchNotification()
            } else if (body.event == "updateContact") {
              const contactPhone = body.data.contactPhone;
              const contactName = body.data.contactName;
              // const employees = body.data.employees.join(', ');
              const message = "Khách hàng " + contactName + '-' + contactPhone + " vừa được chỉnh sửa thông tin.";
              this.notifyMe(message);
              // this.fetchNotification()
            }
          } catch (e) {
            console.log(e);

          }
        });
      });
    },
    async fetchNotification(time, size) {
      const res = await HTTP.get("/api/notification/get-all", { params: { groupTime: time, size: size } });
      if (res.status === "success" && Array.isArray(res.data)) {
        return res.data;
      }
    },
    async fetchNotificationAppointment(time, size) {
      const res = await HTTP.get("/api/notification/get-all-appointment", { params: { groupTime: time, size: size } });
      if (res.status === "success" && Array.isArray(res.data)) {
        return res.data;
      }
    },
    async fetchNotificationTask(time, size) {
      // Task notification list — parallels /get-all-appointment but for the
      // 3 task notification subtypes (TASK_ASSIGN / TASK_REMIND / TASK_AUTOMATION).
      const res = await HTTP.get("/api/notification/get-all-task", { params: { groupTime: time, size: size } });
      if (res.status === "success" && Array.isArray(res.data)) {
        return res.data;
      }
      return [];
    },
    setUnreadCountNoti(key, countUnread) {
      let unreadMap = JSON.parse(localStorage.getItem("notiUnread") || "{}");
      unreadMap[key] = countUnread;
      localStorage.setItem("notiUnread", JSON.stringify(unreadMap));
    },
    setUnreadPreBellClick(key, countUnread) {
      let unreadMap = JSON.parse(localStorage.getItem("preBellClick") || "{}");
      unreadMap[key] = countUnread;
      localStorage.setItem("preBellClick", JSON.stringify(unreadMap));
    },
    handleMessageNoti(data) {
      const contactPhone = data.phone;
      const contactName = data.contactName;
      const source = data.actorUsername;
      switch (data.type) {
        case "CREATE":
          // xử lý tạo mới
          return "Khách hàng " + contactName + "-" + contactPhone + " vừa được thêm mới bởi " + source;

        case "UPDATE_EMPLOYEE":
          // xử lý cập nhật nhân viên
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được chỉnh sửa thông tin bởi " + source;

        case "UPDATE_PROCESS":
          // xử lý cập nhật quy trình
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được thêm mới quy trình bởi " + source;

        case "UPDATE_WORKFLOW":
          // xử lý cập nhật luồng công việc
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được chuyển bước bởi " + source;

        case "UPDATE_STATUS":
          // xử lý cập nhật trạng thái
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được cập nhật trạng thái bởi " + source;

        case "UPDATE_FIELD":
          // xử lý cập nhật trường dữ liệu
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được cập nhật trường thông tin bởi " + source;

        case "CALL":
          // xử lý cuộc gọi
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được thực hiện cuộc gọi bởi " + source;

        case "ORDER":
          // xử lý đơn hàng
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được tạo đơn hàng bởi " + source;

        case "DELETE":
          // xử lý xóa khách hàng
          return "Khách hàng " + contactName + '-' + contactPhone + " vừa được xóa bởi " + source;

        case "MENTION":
          // xử lý xóa khách hàng
          return source + "vừa nhắc tới bạn chú ý tới khách hàng " + contactName + '-' + contactPhone;

        default:
          console.warn("Không xác định action:", data.type);
          break;
      }
    },
    handleMessageNotiAppointment(data) {
      const appointmentName = data.name;
      const contactName = data.contactName;
      const contactPhone = data.phone;

      switch (data.type) {
        case "UPDATE_PARTICIPANTS":
          // xử lý cập nhật nhân viên
          return "Lịch hẹn " + appointmentName + " với " + contactName + " - " + contactPhone + " vừa được thay đổi người tham gia."

        case "UPDATE_STATUS":
          // xử lý cập nhật trạng thái
          return "Lịch hẹn " + appointmentName + " với " + contactName + " - " + contactPhone + " vừa được thay đổi trạng thái."

        case "UPDATE_COLUMN":
          // xử lý cập nhật trường dữ liệu
          return "Lịch hẹn " + appointmentName + " với " + contactName + " - " + contactPhone + " vừa được thay đổi thông tin."

        default:
          console.warn("Không xác định action:", data.type);
          break;
      }
    },
    checkShopExpired() {
      this.app.zaloNotify = true;
      if (!localStorage.getItem("showTour") || this.app.paymentType === "PREPAYMENT" || localStorage.getItem("Notify15052023")) {
        this.app.zaloNotify = false;
      }
    },
    // async fetchNotification() {
    //   const res = await HTTP.get("/api/notification/fetch");
    //   if (res.status == 'success') {
    //     const parsedData = JSON.parse(res.data);
    //     this.app.countNotification = parsedData.data.unreadCount;
    //   }
    // },
    // Ẩn số điện thoại: giữ 5 ký tự đầu + che phần giữa bằng '*' + 3 số cuối.
    // "+84985873972" -> "+8498****972". Số quá ngắn (<=8) giữ nguyên.
    maskPhone(phone) {
      const s = String(phone ?? '').trim();
      if (s.length <= 8) return s;
      return s.slice(0, 5) + '*'.repeat(s.length - 8) + s.slice(-3);
    },
    checkPermission(role) {
      if (!this.app?.user) return false;
      if (this.app.user.type === 'ADMIN') {
        return true;
      } else if (this.app.role?.permissionList) {
        try {
          const roleList = JSON.parse(this.app.role.permissionList);
          return Array.isArray(roleList) && roleList.includes(role);
        } catch (e) {
          return false;
        }
      }
      return false;
    },
    checkPermissionFieldRead(name) {
      if (this.app.user.type === 'ADMIN') {
        return true;
      }
      if (this.app?.role) {
        if (this.app.role?.columnExtendList === "all") {
          return true;
        } else {
          if(this.app.role.columnExtendList){
            const columnExtendList = JSON.parse(this.app.role?.columnExtendList);

            const hasPermission = columnExtendList.some(column => {
              return column.name === name && (column.permission === "READ" || column.permission === "WRITE");
            });

            return hasPermission;
          }
        }
      }
      return false;
    },
    checkPermissionFieldEdit(name) {
      if (this.app.user.type === 'ADMIN') {
        return true;
      }
      if (this.app?.role) {
        if (this.app.role?.columnExtendList === "all") {
          return true;
        } else {
          const columnExtendList = JSON.parse(this.app.role?.columnExtendList);

          const hasPermission = columnExtendList.some(column => {
            return column.name === name && column.permission === "WRITE";
          });

          return hasPermission;
        }
      }
      return false;
    },
    getStorageById(storageId) {
      const storage = this.app.storageAll.find((st) => st.id === storageId);
      return storage ? storage.name : null;
    },
    handleTaskSocket(body) {
      // Normalize task payload — the backend sometimes sends `task` as a JSON
      // string (writeValueAsString), sometimes as a number `taskId`.
      let task = null;
      if (body.task) {
        try { task = typeof body.task === 'string' ? JSON.parse(body.task) : body.task; }
        catch (e) { task = null; }
      }
      const taskId = (task && task.id) || body.taskId || null;
      const code = (task && task.code) || (taskId ? 'CV-' + taskId : 'công việc');
      const title = (task && task.title) || '';

      let message = '';
      let title2 = 'Nhiệm vụ';
      switch (body.type) {
        case 'AUTOMATION':
          message = body.message || ('Tự động hoá đã chạy trên ' + code);
          title2 = '⚡ Tự động hoá';
          break;
        case 'ASSIGN':
          message = 'Bạn được giao việc: ' + code + (title ? ' — ' + title : '');
          title2 = '☑️ Việc mới được giao';
          break;
        case 'REMIND':
          message = 'Nhắc việc: ' + code + (title ? ' — ' + title : '');
          title2 = '⏰ Nhắc việc';
          break;
        case 'UPDATE_FIELD':
        case 'UPDATE':
          message = body.message || ('Cập nhật ' + code + (title ? ' — ' + title : ''));
          title2 = '✏️ Cập nhật nhiệm vụ';
          break;
        case 'LABEL':
          message = body.message || ('Cập nhật nhãn ' + code + (title ? ' — ' + title : ''));
          title2 = '🏷 Cập nhật nhãn';
          break;
        case 'COMMENT':
          message = body.message || ('Bình luận mới trên ' + code + (title ? ' — ' + title : ''));
          title2 = '💬 Bình luận mới';
          break;
        default:
          message = body.message || ('Cập nhật ' + code);
      }

      // 1) Desktop notification (Web Notifications API).
      this.notifyMe(message, title2, taskId);
      // 2) Bump the appointment-notification badge (task notifications are
      //    grouped under the calendar/appointment bell, NOT the regular
      //    contact bell — see NotificationAppointment.vue's merged list).
      this.app.countUnreadNotiAppointment = (this.app.countUnreadNotiAppointment || 0) + 1;
      // 3) Fan out on the event bus so any open task screen can refresh.
      this.$bus.$emit('taskNotification', { type: body.type, taskId, task, message, ruleId: body.ruleId || null });
      // Drop a hint on the appointment-update channel so the open calendar
      // / appointment list can refresh — keeps the merged task+appointment
      // notification list in sync without forcing a manual reload.
      this.$bus.$emit('notiUpdateAppointment', { type: 'TASK', subType: body.type, taskId, message });
    },
    notifyMe(message, customTitle, taskId) {
      const title = customTitle || "Bạn có thông báo mới";
      const showNotif = () => {
        const n = new Notification(title, {
          body: message,
          icon: "/favicon.ico"
        });
        // Click the OS notification → focus window + navigate to the task.
        if (taskId) {
          n.onclick = () => {
            window.focus();
            try { this.$router && this.$router.push('/task').catch(() => {}); } catch (e) { /* ignore */ }
            n.close();
          };
        }
      };
      if (!window.Notification) {
        console.log("Browser does not support notifications.");
      } else if (Notification.permission === 'granted') {
        showNotif();
      } else {
        Notification.requestPermission().then((p) => {
          if (p === 'granted') showNotif();
          else console.log('User blocked notifications.');
        }).catch((err) => console.error(err));
      }
    },
    setTransparencyHex(hex, opacity) {
      let color = hex.substring(1, hex.length);
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return "#" + color + _opacity.toString(16).toUpperCase();
    },
    downSetup(data, fileName = "downloaded_file") {
      try {
        if (typeof data === "string") {
          fetch(data)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.blob();
            })
            .then((blob) => {
              this.createElementDownload(blob, fileName);
            })
            .catch((error) => {
              console.error("Download failed:", error);
            });
        } else {
          const blob = new Blob([data], { type: "audio/wav" });
          this.createElementDownload(blob, fileName);
        }
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    createElementDownload(data, fileName) {
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    normalizePhone(phone) {
      if (!phone) return phone;

      // id nền tảng: conversation_id (a_b_c_d) hoặc t_... — giữ nguyên, không chuẩn hoá như SĐT
      if (/^(\d+_\d+_\d+_\d+|t_\d+)$/.test(phone)) return phone;

      phone = phone.replace(/[^a-zA-Z0-9+]/g, '')
    
      if (phone.startsWith('0')) {
        return '+84' + phone.substring(1);
      } else if (phone.startsWith('84') && !phone.startsWith('+84')) {
        return '+' + phone;
      }
    
      return phone;
    },
    async getContactByIds(contactIds) {
      const contacts = [];
      for (const contactId of contactIds) {
        try {
          const res = await HTTP.get("/api/contact/get-by-id?contactId=" + contactId);
          if (res.error) {
            continue;
          }
          contacts.push(res.data);
        } catch (error) {
          console.error("Lỗi khi lấy contactId:", contactId, error);
        }
      }
      return contacts;
    },
    setPageSizeContact(key, pageSize) {
      let pageSizeMap = JSON.parse(localStorage.getItem("pageSize") || "{}");
      pageSizeMap[key] = pageSize;
      localStorage.setItem("pageSize", JSON.stringify(pageSizeMap));
    },
    getPageSizeCache(key) {
      let pageSizeMap = JSON.parse(localStorage.getItem("pageSize") || "{}");
      return pageSizeMap[key];
    }
  }
})

// Công ty sota chỉ dùng bản mới (/v2). Chặn ở MỌI điều hướng (kể cả client-side
// trong SPA), không chỉ lúc load đầu (verify chỉ chạy 1 lần ở App.vue). Redirect
// thẳng bằng location.replace, không cho ở lại v1.
router.beforeEach((to, from, next) => {
  const cc = String((appState.user && appState.user.companyCode) || "")
    .trim()
    .toLowerCase();
  if (cc === "sota") {
    const path = to.fullPath && to.fullPath !== "/" ? to.fullPath : "/";
    window.location.replace("https://contact.salework.net/v2" + path);
    return; // dừng điều hướng nội bộ; trình duyệt sẽ rời trang
  }
  next();
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')